
    import './styles.scoped.css';
    export default {
  "breadcrumb-group": "awsui_breadcrumb-group_d19fg_oaa01_99",
  "item": "awsui_item_d19fg_oaa01_137",
  "breadcrumb-group-list": "awsui_breadcrumb-group-list_d19fg_oaa01_172",
  "ellipsis": "awsui_ellipsis_d19fg_oaa01_184",
  "icon": "awsui_icon_d19fg_oaa01_194",
  "mobile": "awsui_mobile_d19fg_oaa01_199",
  "mobile-short": "awsui_mobile-short_d19fg_oaa01_212"
};
  